import { all } from '../data/all';
import CountriesByAlphabet from './CountriesByAlphabet';

function Countries() {

    let countryNames = [];
    all.forEach(country => {
        countryNames.push(country.name.common);
    });
    countryNames.sort();

    // https://stackoverflow.com/questions/49837432/how-to-split-array-of-strings-into-sets-of-arrays-alphabetically-in-javascript
    // by Gabriel P on Oct 16, 2019 at 17:11
    const getSections = (words) => {
        if (words.length === 0) {
            return [];
        }
        return Object.values(
            words.reduce((acc, word) => {
                let firstLetter = word[0].toLocaleUpperCase();
                if (!acc[firstLetter]) {
                    acc[firstLetter] = { title: firstLetter, data: [word] };
                } else {
                    acc[firstLetter].data.push(word);
                }
                return acc;
            }, {})
        );
    }

    let countriesByFirstLetter = getSections(countryNames);

    return (
        <section className="columns is-mobile is-multiline">
            {countriesByFirstLetter.map((alpha, index) => {
                return (
                    <CountriesByAlphabet key={index} letter={alpha.title} countries={alpha.data} />
                )
            })}
        </section>
    )

}

export default Countries;